<div class="modal-body">
  <div class="content" *ngIf="!loading.initialValues">
    <div class="content__top">
      <h4 translate>company.dids.replace-with-did.popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__form" [formGroup]="form">
      <div class="form-group">
        <label for="replace-did-old-phone" translate>company.dids.replace-with-did.popup.form.old-phone.label</label>
        <div class="vox-input-group vox-input-group_dense">
          <input class="vox-text-field" type="text" id="replace-did-old-phone" formControlName="oldPhone" readonly>
        </div>
      </div>
      <div class="form-group">
        <label for="replace-did-country" translate>company.dids.replace-with-did.popup.form.country.label</label>
        <vox-select-country [language]="currentLanguage" [dense]="true" formControlName="country">
        </vox-select-country>
      </div>
      <div class="form-group">
        <label for="replace-did-prefix" translate>company.dids.replace-with-did.popup.form.prefix.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
            'vox-input-group_invalid': isFieldValid('prefix')}">
          <vox-select-prefix [language]="currentLanguage" [dense]="true" [country]="form.value.country.iso2"
            formControlName="prefix">
          </vox-select-prefix>
          <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
          <span class="vox-input-group__error-message"
            translate>company.dids.replace-with-did.popup.form.error.required</span>
        </div>
      </div>
      <div class="form-group">
        <label for="replace-did-class" translate>company.dids.replace-with-did.popup.form.class.label</label>
        <div ngbDropdown class="dropdown">
          <button class="dropdown__btn" id="replace-did-class" ngbDropdownToggle disabled>
            <span>{{form.value.class | didClass}}</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="replace-did-class">
            <button ngbDropdownItem class="dropdown__item" *ngFor="let class of availableClasses"
              (click)="selectClass(class)"><span>{{class | didClass}}</span></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="replace-did-type" translate>company.dids.replace-with-did.popup.form.type.label</label>
        <div ngbDropdown class="dropdown">
          <button class="dropdown__btn" id="replace-did-type" ngbDropdownToggle>
            <span>{{form.value.type | didType}}</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="replace-did-type">
            <button ngbDropdownItem class="dropdown__item" *ngFor="let type of availableTypes"
              (click)="selectType(type)"><span>{{type | didType}}</span></button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="replace-did-coupon-id" translate>company.dids.replace-with-did.popup.form.coupon-id.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('couponId')}">
          <input class="vox-text-field" type="text" id="replace-did-coupon-id" formControlName="couponId"
            [placeholder]="'company.dids.replace-with-did.popup.form.coupon-id.placeholder' | translate"><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message"
            translate>company.dids.replace-with-did.popup.form.error.required</span>
        </div>
      </div>
      <div class="form-group">
        <label for="replace-did-verification-data"
          translate>company.dids.replace-with-did.popup.form.verification-data.label</label>
        <div class="dropdown-container" *ngIf="verificationData">
          <div ngbDropdown class="dropdown">
            <button class="dropdown__btn" id="replace-did-verification-data" ngbDropdownToggle>
              <ng-container *ngIf="verificationData.type === 'PRIVATE'">
                <span *ngIf="verificationData.label">
                  {{verificationData.label}} - {{verificationData.first_name}} {{verificationData.last_name}}
                </span>
                <span *ngIf="!verificationData.label">
                  {{verificationData.first_name}} {{verificationData.last_name}}
                </span>
              </ng-container>
              <ng-container *ngIf="verificationData.type === 'BUSINESS'">
                <span *ngIf="verificationData.label">
                  {{verificationData.label}} - {{verificationData.company_name}}
                </span>
                <span *ngIf="!verificationData.label">
                  {{verificationData.company_name}}
                </span>
              </ng-container>
            </button>
            <div class="dropdown__menu" ngbDropdownMenu aria-labelledby="replace-did-verification-data">
              <button ngbDropdownItem class="dropdown__item" *ngFor="let data of verificationDataList"
                (click)="selectVerificationData(data)">
                <ng-container *ngIf="data.type === 'PRIVATE'">
                  <span *ngIf="data.label">
                    {{data.label}} - {{data.first_name}} {{data.last_name}}
                  </span>
                  <span *ngIf="!data.label">
                    {{data.first_name}} {{data.last_name}}
                  </span>
                </ng-container>
                <ng-container *ngIf="data.type === 'BUSINESS'">
                  <span *ngIf="data.label">
                    {{data.label}} - {{data.company_name}}
                  </span>
                  <span *ngIf="!data.label">
                    {{data.company_name}}
                  </span>
                </ng-container>
              </button>
            </div>
          </div>
          <button class="vox-btn vox-btn-secondary" (click)="showVerificationData = !showVerificationData">
            <span *ngIf="!showVerificationData" translate>common.show</span>
            <span *ngIf="showVerificationData" translate>common.hide</span>
          </button>
        </div>
        <div class="vox-inline-message vox-inline-message_light-grey" *ngIf="!verificationData">
          <div>
            <i class="icon-small-info"></i>
            <span translate>company.dids.replace-with-did.popup.form.verification-data.empty</span>
          </div>
        </div>
      </div>
      <vox-vd-table-readonly *ngIf="showVerificationData" [data]="form.value.verificationData"
        [language]="currentLanguage"></vox-vd-table-readonly>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" type="submit" (click)="onSubmit()" [disabled]="form.invalid"
          [ladda]="loading.submit" data-style="zoom-in" data-spinner-color="#fff">
          <span translate>company.dids.replace-with-did.popup.form.save</span>
        </button>
      </div>
    </div>
  </div>
  <div class="content" *ngIf="loading.initialValues">
    <ngx-skeleton-loader [theme]="{ 'height': '500px', 'margin-bottom': 0, 'outline': '0px' }"></ngx-skeleton-loader>
  </div>
</div>